export class RemuneracaoCreditoLivre {
  public ideIndexadorAtualizacaoGarantia: number;
  public dataInicial: Date;
  public dataFinal: Date;
  public valorOperacao: number;
  public valorTaxaAdicional?: number;

  public resultado?: number;
}

export class RemuneracaoCentral {
  public ideOperacaoGarantida: number;
  public valorEmReaisASerRemunerado: number;
  public dataInicioRemuneracao: Date;
  public dataFimRemuneracao: Date
  public remuneracaoPorFatores: boolean;

  public descricaoTaxaAtualizacao?: string;
  public resultado?: number;
}

export class RemuneracaoRepasse {
  public valorARemunerar: number;
  public dataInicial: Date;
  public dataFinal: Date;
  public numeroContratoScc: number;
  public numeroSistemaScc: number;

  public resultado?: RespostaRemuneracao;
}

export class EntradaRemuneracaoCreditoLivreDTO {
  public ideIndexadorAtualizacaoGarantia: number;
  public dataInicial: string;
  public dataFinal: string;
  public valorOperacao: number;
  public valorTaxaAdicional?: number;
}

export class EntradaRemuneracaoCentralDTO {
  public ideOperacaoGarantida: number;
  public valorEmReaisASerRemunerado: number;
  public dataInicioRemuneracao: string;
  public dataFimRemuneracao: string
  public remuneracaoPorFatores: boolean;
}

export class EntradaRemuneracaoRepasseDTO {
  public valorARemunerar: number;
  public dataInicial: string;
  public dataFinal: string;
  public numeroContratoScc: number;
  public numeroSistemaScc: number;
}

export class RespostaRemuneracao {
  public valorRemunerado: number;
  public detalhesRemuneracao: string;
}